import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CommonDataKeys, initialState } from './CommonData.constants';
import type { CommonDataState, SetCommonDataAction } from './CommonData.types';

// This slice is used to store data that should be shared across the app
// The idea is to fetch such data once and then use it in multiple places
// We assume that this data will not change during the session, so what should be rarely updated data

const commonDataSlice = createSlice({
  initialState,
  name: 'commonData',
  reducers: {
    RESET() {
      return initialState;
    },
    SET_COMMON_DATA_FIELD<K extends CommonDataKeys>(
      state: CommonDataState,
      action: PayloadAction<SetCommonDataAction<K>>
    ) {
      state[action.payload.key] = action.payload.data;
    },
  },
});

export const commonDataReducer = commonDataSlice.reducer;
export const commonDataActions = commonDataSlice.actions;
